<template lang="pug">

    .field

        .ui.toggle.checkbox(v-bind:class='{ disabled: disabled }')
            input(type="checkbox" v-bind:disabled='disabled' v-uni-id='"checkbox"' v-model='mutable')
            label(v-uni-for='"checkbox"') {{ label }}

        slot

</template>

<script>
    export default {

        computed: {
            mutable: {
                get() { return this.value },
                set(value) {
                    if (!this.disabled) {
                        this.$emit('input', value)
                    }
                }
            }
        },

        props: {

            disabled: {
                type: Boolean,
                default: false
            },

            label: {
                type: String,
                required: true
            },

            value: {
                type: Boolean,
                required: true
            }

        }

    }

</script>
